import FeatureGates from '@atlaskit/feature-gate-js-client';

export const CROSS_JOIN_NUDGES_V3_EXPERIMENT_KEY = 'cross_join_nudges_v3_experiment';

const COHORT = 'cohort';
export const NOT_ENROLLED = 'not-enrolled';
export const VARIATION = 'variation';
export const CONTROL = 'control';

export const getExperimentCohort = ({ fireExposure } = { fireExposure: false }) => {
	try {
		return FeatureGates.getExperimentValue<string>(
			CROSS_JOIN_NUDGES_V3_EXPERIMENT_KEY,
			COHORT,
			NOT_ENROLLED,
			{
				fireExperimentExposure: fireExposure,
			},
		);
	} catch {
		return NOT_ENROLLED;
	}
};

export const isExperimentEnabled = () => getExperimentCohort({ fireExposure: false }) === VARIATION;
